/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Box } from '@material-ui/core';
import ChipHelper from './chipHelper';

const brandFields = [
  { fieldName: 'BRAND_NAME' },
  { fieldName: 'BRAND_WEBSITE' },
  { fieldName: 'BRAND_ADDRESS' },
  { fieldName: 'BRAND_STATE' },
  { fieldName: 'BRAND_COUNTRY' },
  { fieldName: 'BRAND_PHONENUMBER' },
];

const productFields = [
  { fieldName: 'PRODUCT_NAME' },
  { fieldName: 'PRODUCT_HOTSITE' },
  { fieldName: 'PRODUCT_APPURL' },
  { fieldName: 'PRODUCT_TOSLINK' },
  { fieldName: 'PRODUCT_CATEGORY' },
  { fieldName: 'PRODUCT_COMPATIBILITY' },
  { fieldName: 'PRODUCT_LAST_UPDATED' },
  { fieldName: 'PRODUCT_VERSON' },
];

const presellFields = [
  { fieldName: 'PRESELL_TITLES' },
  { fieldName: 'READ_MORE' },
];

const DynamicFields = ({ dynamicFieldsList, dynamicFieldsConfig, editor }) => {
  const addFieldInContent = (field) => {
    editor.model.change((writer) => {
      writer.insertText(
        ` {{${field}}} `,
        editor.model.document.selection.getFirstPosition(),
      );
    });
  };

  return (
    <Box mb={1}>
      {dynamicFieldsConfig.showBrandDynamicFields && (
        <>
          {brandFields.map((c) => {
            return (
              <ChipHelper
                c={c}
                className="brand"
                addFieldInContent={addFieldInContent}
                key={c.fieldName}
              />
            );
          })}
          <br />
        </>
      )}
      {dynamicFieldsConfig.showProductDynamicFields && (
        <>
          {productFields.map((c) => {
            return (
              <ChipHelper
                c={c}
                className="product"
                addFieldInContent={addFieldInContent}
                key={c.fieldName}
              />
            );
          })}
          <br />
        </>
      )}
      {dynamicFieldsConfig.showPresellDynamicFields && (
        <>
          {presellFields.map((c) => {
            return (
              <ChipHelper
                c={c}
                className="presell"
                addFieldInContent={addFieldInContent}
                key={c.fieldName}
              />
            );
          })}
          <br />
        </>
      )}
      {dynamicFieldsList
        && JSON.parse(dynamicFieldsList).map((c) => {
          return (
            <ChipHelper
              c={c}
              addFieldInContent={addFieldInContent}
              key={c.fieldName}
            />
          );
        })}
    </Box>
  );
};

export default React.memo(DynamicFields);
